import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {EventTotalKpi} from '../HazardAIEventTotal/EventTotalKpi';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}

export const HazardAITotalWarningEvents = (props?: Props) => (
  <EventTotalKpi
    {...props}
    zone="warning"
    label="Total Warning Events"
    errorId="STRA_b8d2e4f6"
  />
);
